module.exports = __webpack_public_path__ + "img/pcr-icon.34451f9c.svg";